<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">商城设置</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商城设置
      <small>商城设置...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商城设置">
      <div class="row content">
        <div class="col-md-4">
          <Card :bordered="false">
            <p slot="title">优惠券获取配置[优惠券有效期过期将失效]</p>
            <giftcomponent></giftcomponent>
          </Card>
          <Card :bordered="false">
            <p slot="title">商城设置</p>
            <emshopHome></emshopHome>
          </Card>
        </div>
        <div class="col-md-8">
          <!-- 关于我们设置 -->
        </div>
      </div>
    </panel>
  </div>
</template>
<script>
import giftcomponent from "./giftcomponent";
import emshopHome from "./emshopHome";

export default {
  components: { giftcomponent, emshopHome },
  data() {
    return {
      giftset: {}
    };
  },
  mounted() {},
  methods: {}
};
</script>